import React, { useEffect, useRef } from "react";
import * as Plotly from "plotly.js";

const PieChart = ({ alarms, setAlarmUrl }) => {
  const plotRef = useRef(null);

  useEffect(() => {
    if (alarms) {
      const alarmsValue = alarms.data.Alarms;
      const uniqueAlarms = alarmsValue
        .map(({ AlarmId }) => AlarmId)
        .reduce((AlarmIds, AlarmId) => {
          const count = AlarmIds[AlarmId] || 0;
          AlarmIds[AlarmId] = count + 1;
          return AlarmIds;
        }, {});

      let values = [];
      let labels = [];

      for (var key in uniqueAlarms) {
        values.push(uniqueAlarms[key]);
        labels.push(key);
      }

      let data = [{ labels: labels, values: values, type: "pie" }];
      const layout = {
        height: 480,
        width: 640,
        legend: {
          font: {
            size: 10
          }
        }
      };
      if (data && plotRef) {
        Plotly.newPlot("plotly_div", data, layout, { displayModeBar: false, staticPlot: true }).then(function (gd) {
          Plotly.toImage(gd, { height: 480, width: 640, format: "png" }).then(function (url) {
            setAlarmUrl(url);
          });
        });
      }
    }
  }, [alarms]);

  return <div className="displayNone" id={"plotly_div"} ref={plotRef} />;
};

export default PieChart;
